import React, { useContext } from "react";

import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";

function ContactCardpeasant({ preview }) {
  const [cardData] = useContext(CardContext);

  const {
    personalDetails,
    vCard,
    contactDetails,
    Hcolor,
    phoneNumbers,
    emailList,
  } = cardData;

  // const Highlightcolor = Hcolor.hex ? Hcolor?.hex : "";
  const shareMail = (e) => {
    window.location = `mailto:${personalDetails?.email}`;
    e.preventDefault();
  };
  const shareMail2 = (e) => {
    window.location = `mailto:${personalDetails?.secondaryEmail}`;
    e.preventDefault();
  };
  return (
    <>
      <div className="flex justify-start items-center mt-[40px] gap-2 w-full">
        <div className="w-[70%]">
          <p className="text-white text-[19px] font-semibold flex items-center text-start">
            Contact Info
          </p>
        </div>
        <div className="flex items-center pb-1 w-full">
          <p className="w-[13px] flex items-center rounded-full h-[13px] bg-white"></p>
          <p className="w-full h-[2px] bg-white"></p>
        </div>
      </div>

      <div className="grid gap-3 grid-cols-2 items-center justify-start ">
      
        <div className=" ">
          <div className="flex items-center gap-2 justify-start ">
            <div>
              <svg
                width="39"
                height="40"
                viewBox="0 0 39 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="19.225"
                  cy="20"
                  r="19.225"
                  fill="white"
                  fill-opacity="0.2"
                />
                <path
                  d="M23.18 26.5625C22.6081 26.5625 21.8048 26.3557 20.6019 25.6836C19.1391 24.8633 18.0076 24.106 16.5527 22.6549C15.15 21.253 14.4674 20.3454 13.512 18.6069C12.4327 16.644 12.6167 15.6151 12.8224 15.1754C13.0673 14.6498 13.4288 14.3355 13.8961 14.0234C14.1615 13.8495 14.4424 13.7005 14.7352 13.5781C14.7645 13.5655 14.7917 13.5535 14.816 13.5427C14.961 13.4773 15.1808 13.3786 15.4591 13.4841C15.6448 13.5538 15.8107 13.6965 16.0702 13.9528C16.6025 14.4778 17.33 15.6471 17.5983 16.2213C17.7785 16.6083 17.8978 16.8638 17.8981 17.1503C17.8981 17.4857 17.7293 17.7444 17.5245 18.0236C17.4861 18.0761 17.4481 18.1262 17.4111 18.1748C17.1882 18.4678 17.1393 18.5524 17.1715 18.7036C17.2368 19.0074 17.724 19.9118 18.5247 20.7107C19.3254 21.5097 20.2037 21.9661 20.5087 22.0312C20.6663 22.0648 20.7527 22.0139 21.0551 21.783C21.0984 21.7499 21.143 21.7156 21.1896 21.6814C21.5019 21.449 21.7485 21.2847 22.0761 21.2847H22.0778C22.3629 21.2847 22.6069 21.4083 23.0112 21.6122C23.5386 21.8782 24.743 22.5963 25.2712 23.1292C25.5281 23.3882 25.6714 23.5534 25.7414 23.7389C25.8469 24.0181 25.7476 24.2369 25.6828 24.3834C25.672 24.4077 25.66 24.4344 25.6474 24.464C25.5241 24.7562 25.3741 25.0365 25.1994 25.3013C24.888 25.7671 24.5725 26.1277 24.0457 26.373C23.7752 26.5009 23.4792 26.5657 23.18 26.5625Z"
                  fill="white"
                />
              </svg>
            </div>
            <div>
              {" "}
              {personalDetails?.phone  ? 
              <Link
                className="text-sm font-semibold  w-full h-[19px] flex justify-left items-center  "
                to={preview ? `tel:+${personalDetails?.phone}` : ""}
              >
                +
                {personalDetails?.phone
                  ? personalDetails.phone
                  : "123 456 7890"}
              </Link>
              : "" }
              {personalDetails?.secondaryPhone ? (
                <Link
                  className="text-sm font-semibold  w-full h-[19px] flex justify-left items-center  "
                  to={preview ? `tel:+${personalDetails?.secondaryPhone}` : ""}
                >
                  +
                  {personalDetails?.secondaryPhone
                    ? personalDetails.secondaryPhone
                    : "123 456 7890"}
                </Link>
              ) : (
                ""
              )}
              {phoneNumbers?.map((phone) => (
                <Link
                  // key={phone}
                  className="text-sm font-semibold w-full h-[19px] flex justify-left items-center"
                  to={preview ? `tel:${phone.number}` : ""}
                >
                  + {phone.number || "123 456 7890"}
                </Link>
              ))}
            </div>
          </div>
        </div>
       
        <div className="">
          <div className="flex items-center gap-2  justify-start ">
            <div className="">
              <svg
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="19.775"
                  cy="20"
                  r="19.225"
                  fill="white"
                  fill-opacity="0.2"
                />
                <path
                  d="M19.775 10.9742C16.6467 10.9742 14.1165 13.5567 14.1165 16.7498C14.1165 21.0814 19.775 27.4758 19.775 27.4758C19.775 27.4758 25.4335 21.0814 25.4335 16.7498C25.4335 13.5567 22.9033 10.9742 19.775 10.9742ZM19.775 18.8125C19.239 18.8125 18.725 18.5951 18.346 18.2083C17.967 17.8215 17.7541 17.2968 17.7541 16.7498C17.7541 16.2027 17.967 15.678 18.346 15.2912C18.725 14.9044 19.239 14.6871 19.775 14.6871C20.311 14.6871 20.825 14.9044 21.204 15.2912C21.583 15.678 21.7959 16.2027 21.7959 16.7498C21.7959 17.2968 21.583 17.8215 21.204 18.2083C20.825 18.5951 20.311 18.8125 19.775 18.8125Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="">
              <p className="text-[14px] text-white font-medium pt-3 flex items-center text-start overflow-auto w-[100px] scrollbar-hide">
                {" "}
                {contactDetails?.address
                  ? contactDetails.address
                  : "2709 Hwy 51,Janesville"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className=" flex mt-[20px] justify-center">
        <div className="flex  gap-2 justify-start items-center">
          <div>
            <svg
              width="39"
              height="40"
              viewBox="0 0 39 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="19.225"
                cy="20"
                r="19.225"
                fill="white"
                fill-opacity="0.2"
              />
              <path
                d="M26.3873 17.2005V23.5811C26.3873 24.1747 26.1515 24.744 25.7317 25.1638C25.312 25.5835 24.7427 25.8193 24.1491 25.8193H14.301C13.7074 25.8193 13.1381 25.5835 12.7184 25.1638C12.2986 24.744 12.0628 24.1747 12.0628 23.5811V17.2005L18.9977 21.2811C19.0666 21.3218 19.1451 21.3432 19.2251 21.3432C19.305 21.3432 19.3836 21.3218 19.4525 21.2811L26.3873 17.2005ZM24.1491 14.1807C24.6998 14.1806 25.2312 14.3836 25.6417 14.7508C26.0522 15.1179 26.3128 15.6236 26.3738 16.1709L19.2251 20.376L12.0763 16.1709C12.1373 15.6236 12.398 15.1179 12.8084 14.7508C13.2189 14.3836 13.7503 14.1806 14.301 14.1807H24.1491Z"
                fill="white"
              />
            </svg>
          </div>
          <div className=" ">
            <p className="text-[14px] text-white font-medium pt-3 flex items-center text-center overflow-auto w-[200px] scrollbar-hide">
              <Link onClick={preview ? shareMail : ""}>
                {personalDetails?.email
                  ? personalDetails.email
                  : ""}
              </Link>

              <div className="mt-2">
                <Link onClick={preview ? shareMail2 : ""}>
                  {personalDetails?.secondaryEmail
                    ? personalDetails.secondaryEmail
                    : ""}
                </Link>
              </div>

            </p>
            <div className="flex flex-col">

{emailList?.map((email) => (
  <Link
    className="text-sm font-semibold w-full h-[19px] flex justify-left items-center"
    to={preview ? `mailto:${email?.email}` : ""}
  >
    {email?.email}
  </Link>
))}
</div>
            
          </div>
        </div>
      </div>

      <div></div>
    </>
  );
}

export default ContactCardpeasant;
